import { Web3Button } from '@thirdweb-dev/react'
import { MarketplaceV3, SmartContract } from '@thirdweb-dev/sdk'
import { BaseContract } from 'ethers'
import { Spinner } from '~/components/Spinner'
import styles from './index.module.scss'

interface W3ButtonWrapperProps {
  size?: string
  hierarchy?: string
  isLoading?: boolean
  contract: MarketplaceV3 | SmartContract<BaseContract>
  action: () => void
  onSubmit: () => void
  isDisabled:boolean
}

export const W3ButtonWrapper: React.FC<React.PropsWithChildren<W3ButtonWrapperProps>> = ({
  size,
  hierarchy,
  isLoading,
  contract,
  action,
  onSubmit,
  isDisabled,
  children,
}) => {

  return (
    <Web3Button
      className={ `
        ${styles['w3wrapper']}
        ${isLoading && styles['w3wrapper--loading']}
        ${isDisabled && styles['w3wrapper--disabled']}
        ${size && styles[`w3wrapper--${size}`]}
        ${hierarchy && styles[`w3wrapper__${hierarchy}`]}
      ` }
      contractAddress={ contract.getAddress() }
      action={ action }
      onSubmit={ onSubmit }
      isDisabled={ isDisabled }
    >
      {
        isLoading && !isDisabled &&
          <Spinner/>
      }
      { children }
    </Web3Button>
  )
}